import { useState, useEffect } from "react";
import { Box, Typography, TextField, Divider } from "@mui/material";
import { UseWalletReport } from "./UseWalletReport";
import Detail from "../../main/detail/Detail";
import { rsActiveMenu, rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { useLocation } from "react-router-dom";
import { UseMyPC } from "../../hooks/UseMyPC";
import { DataGrid, faIR } from "@mui/x-data-grid";
import CustomPagination from "../../components/CustomPagination";
import { deCapitalizeFirstLetter, toMoney } from "../../util/Utils";
import ProgressCom from "../../components/ProgressCom";
import FilterSearch from "./FilterSearch";

export default function WalletReport(props) {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const { myPc, updatePage, updateSort } = UseMyPC("ShamsiLogdate", "Desc");
  const { GetWalletReport } = UseWalletReport();
  const [reportRes, setReportRes] = useState();
  const [state, setState] = useState("");
  const [add, setAdd] = useState("");
  const [mobile, setMobile] = useState("");
  const [progress, setProgress] = useRecoilState(rsProgress);

  useEffect(() => {
    setProgress(true);
    GetWalletReport(mobile, add, state, myPc, true, (callback) => {
      setReportRes(callback);
    });
  }, [myPc, state, add, mobile]);

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "ID",
      headerAlign: "center",
      hide: true,
    },
    {
      field: "rowNO",
      width: 80,
      align: "center",
      headerName: "ردیف",
      sortable: false,
      headerAlign: "center",
    },
    {
      field: "fullName",
      width: 150,
      align: "center",
      headerName: "کاربر",
      headerAlign: "center",
      sortable: false,
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "normal",
            }}
          >
            {cellValues.row.fullName}
          </Typography>
        );
      },
    },
    {
      field: "mobile",
      headerName: "موبایل",
      width: 120,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "shamsiLogdate",
      headerName: "تاریخ",
      width: 120,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "cost",
      headerName: "درخواستی",
      width: 120,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return cellValues.row.type == 1 ? (
          <Typography
            variant="span"
            sx={{
              direction: "rtl",
              whiteSpace: "normal",
            }}
          >
            {cellValues.row.cost ? "+ " + toMoney(cellValues.row.cost) : 0}
          </Typography>
        ) : (
          <Typography
            variant="span"
            sx={{
              direction: "rtl",
              whiteSpace: "normal",
            }}
          >
            {cellValues.row.cost ? "- " + toMoney(cellValues.row.cost) : 0}
          </Typography>
        );
      },
    },
    {
      field: "giftCost",
      headerName: "هدیه",
      width: 120,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "normal",
            }}
          >
            {cellValues.row.giftCost ? toMoney(cellValues.row.giftCost) : 0}
          </Typography>
        );
      },
    },
    {
      field: "totalCost",
      headerName: "موجودی کیف پول",
      width: 140,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "normal",
            }}
          >
            {cellValues.row.totalCost ? toMoney(cellValues.row.totalCost) : 0}
          </Typography>
        );
      },
    },
    {
      field: "typeTitle",
      headerName: "عنوان",
      width: 130,
      align: "center",
      headerAlign: "center",

      renderCell: (cellValues) => {
        return (
          <Box>
            {cellValues.row.type == 1 && (
              <Typography
                variant="span"
                sx={{
                  color: "green",
                  whiteSpace: "normal",
                }}
              >
                {cellValues.row.typeTitle}
              </Typography>
            )}
            {cellValues.row.type == 2 && (
              <Typography
                variant="span"
                sx={{
                  color: "red",
                  whiteSpace: "normal",
                }}
              >
                {cellValues.row.typeTitle}
              </Typography>
            )}
          </Box>
        );
      },
    },
    {
      field: "stateTitle",
      headerName: "وضعیت",
      width: 110,
      align: "center",
      headerAlign: "center",
      sortable: false,
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "گزارشات",
        childs: [{ name: msActiveMenu.pageTitle, url: "/walletreport" }],
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Box
          sx={{
            mb: 1,
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <FilterSearch
            setState={setState}
            state={state}
            add={add}
            setAdd={setAdd}
            mobile={mobile}
            setMobile={setMobile}
          />
        </Box>
        <Box sx={{ flexGrow: 1 }}>
          {reportRes ? (
            <DataGrid
              className="ltr-grid"
              localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
              columns={columns}
              pageSize={
                reportRes && reportRes.pageCondition
                  ? reportRes.pageCondition.pageCount
                  : 1
              }
              rows={reportRes ? reportRes.wallets : []}
              paginationMode="server"
              page={
                reportRes && reportRes.pageCondition
                  ? reportRes.pageCondition.page - 1
                  : 1
              }
              onPageChange={(page) => {
                updatePage(page + 1);
              }}
              rowCount={
                reportRes && reportRes.pageCondition
                  ? reportRes.pageCondition.totalItemCount
                  : 1
              }
              enableRangeSelection={true}
              disableColumnMenu
              hideFooterSelectedRowCount
              components={{
                Pagination: CustomPagination,
              }}
              componentsProps={{
                pagination: {
                  scrollTo: myPc.scrollTo,
                  isLtr: true,
                  nofab: true,
                  rowCount:
                    reportRes && reportRes.pageCondition
                      ? reportRes.pageCondition.totalItemCount
                      : "",
                },
              }}
              initialState={{
                sorting: {
                  sortModel: [
                    {
                      field: deCapitalizeFirstLetter(myPc.sortColumn),
                      sort: deCapitalizeFirstLetter(myPc.sortOrder),
                    },
                  ],
                },
                pagination: {
                  page: myPc.page,
                },
              }}
              onSortModelChange={(model) => {
                updateSort(
                  model[0].field,
                  model[0].sort == "asc" ? "asc" : "desc"
                );
              }}
              sortingOrder={["desc", "asc"]}
              sortingMode="server"
              sx={{
                "& .MuiDataGrid-cell:focus": {
                  outline: "none",
                },
                "&  .MuiDataGrid-columnHeader:focus-within": {
                  outline: "none",
                },
                "&  .MuiDataGrid-cell:focus-within ": {
                  outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
                },
                "& .muirtl-hnxuso-MuiDataGrid-root .MuiDataGrid-cell:focus-within":
                  {
                    outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
                  },
                "& .MuiDataGrid-cell:hover": {
                  opacity: "80%",
                  cursor: "pointer",
                },
                "& .MuiDataGrid-virtualScrollerRenderZone": {
                  width: "100% !important",
                },
                "& .orange": {
                  backgroundColor: "#FFC36E !important",
                },

                "& .Green": {
                  backgroundColor: "#56ff004f !important",
                },
                "& .red": {
                  backgroundColor: "#ff9c9c !important",
                },
              }}
              getRowClassName={(params) => {
                if (params.row.state == 1) {
                  return "Green";
                }
                if (params.row.state == 2) {
                  return "red";
                }
                if (params.row.state == 3) {
                  return "orange";
                }
              }}
            />
          ) : (
            <ProgressCom></ProgressCom>
          )}
        </Box>
      </Box>
    </Detail>
  );
}
